import { useLayoutEffect, useState } from 'react'

const BREAKPOINTS = {
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    xl2: false
}

export default function useBreakpoints() {
    const [breakpoint, setBreakpoint] = useState({
        ...BREAKPOINTS,
        xs: true
    })

    useLayoutEffect(() => {
        function updateSize() {
            const w = window.innerWidth
            if (w <= 640)
                setBreakpoint({
                    ...BREAKPOINTS,
                    xs: true
                })
            else if (w <= 768)
                setBreakpoint({
                    ...BREAKPOINTS,
                    sm: true
                })
            else if (w <= 1024)
                setBreakpoint({
                    ...BREAKPOINTS,
                    md: true
                })
            else if (w <= 1280)
                setBreakpoint({
                    ...BREAKPOINTS,
                    lg: true
                })
            else if (w <= 1536)
                setBreakpoint({
                    ...BREAKPOINTS,
                    xl: true
                })
            else
                setBreakpoint({
                    ...BREAKPOINTS,
                    xl2: true
                })
        }
        window.addEventListener('resize', updateSize)
        updateSize()
        return () => window.removeEventListener('resize', updateSize)
    }, [])

    return breakpoint
}
